import actions from '@/core/store/ata/fiscais/actions'

export default {
	actions,
}
